import { clsx } from 'clsx';
import { formatAmountWithSpaces } from '@/lib/amountUtils';
import {
  coinsIcon,
  creditCardIcon,
  oceanLogoOnBlue,
  oceanLogoOnYellow,
} from '@/assets/images/offer/tiers';
import styles from './OceanOfferFace.module.scss';

export type OceanOfferType = 'credit-line' | 'installment';

export interface OceanOfferFaceProps {
  type: OceanOfferType;
  amount: number;
  numberOfRates: number;
  className?: string;
}

const LABELS: Record<OceanOfferType, string> = {
  'credit-line': 'Linie de credit',
  installment: 'Credit în rate',
};

export function OceanOfferFace({
  type,
  amount,
  numberOfRates,
  className,
}: OceanOfferFaceProps) {
  const isCreditLine = type === 'credit-line';

  return (
    <div className={clsx(styles.root, styles[`root--${type}`], className)}>
      <div className={styles.overlay} aria-hidden />

      <div className={styles.header}>
        <img
          src={isCreditLine ? oceanLogoOnBlue : oceanLogoOnYellow}
          alt="Ocean Credit"
          className={styles.logo}
        />
        <div className={styles.visual} aria-hidden>
          <img
            src={isCreditLine ? creditCardIcon : coinsIcon}
            alt=""
            className={isCreditLine ? styles.creditCard : styles.coins}
          />
        </div>
      </div>

      <div className={styles.bottom}>
        <div className={styles.balance}>
          <p className={styles.label}>{LABELS[type]}</p>
          <p className={styles.sum}>
            <span className={styles.amount}>{formatAmountWithSpaces(amount)}</span>
            <span className={styles.currency}>lei</span>
          </p>
        </div>
        <p className={styles.period}>
          <span className={styles.periodValue}>{numberOfRates}</span>
          <span className={styles.periodUnit}>luni</span>
        </p>
      </div>
    </div>
  );
}
